export const MAX_RANGE = 200;
export const MAX_LABEL = 40;

export type TableInput =
    { kind: 'none' } | { kind: 'range'; from: number; to: number } | { kind: 'list'; labels: string[] } | { kind: 'error'; reason: 'range' | 'tooLong' };

/** Empty = one code without a label; "1-12" = numbered range; anything else = comma separated labels ("A1, Terrace 4, Bar"). */
export const parseTableInput = (raw: string): TableInput => {
    const text = raw.trim();
    if (!text) return { kind: 'none' };
    const range = /^(\d+)\s*[-–]\s*(\d+)$/.exec(text);
    if (range) {
        const from = Number(range[1]);
        const to = Number(range[2]);
        return from >= 1 && to >= from && to <= MAX_RANGE ? { kind: 'range', from, to } : { kind: 'error', reason: 'range' };
    }
    const labels = [
        ...new Set(
            text
                .split(',')
                .map((s) => s.trim())
                .filter(Boolean)
        ),
    ];
    if (labels.length === 0) return { kind: 'none' };
    if (labels.some((n) => n.length > MAX_LABEL)) return { kind: 'error', reason: 'tooLong' };
    return { kind: 'list', labels };
};
